/**************************************************
 * Nombre:       Seccion_Detalle_Oferta
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Indicadores from "./Componentes/Home_Indicadores";
import Home_Documentos from "./Componentes/Home_Documentos";
import Home_Preguntas from "./Componentes/Home_Preguntas";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Detalle_Educacion from "./Componentes/Detalle_Educacion";
import Detalle_Complementos from "./Componentes/Detalle_Complementos";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../App";
import {useParams} from "react-router";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Detalle_Oferta = () => {
    const cData = useContext(contexApp)
    const parms = useParams()
    const {sCell} = useResponsive()
    const [curso, setCurso] = useState({})


    useEffect(() => {

        if (parms && parms.nombre) {

            irArriba()

            let nombre = parms.nombre.replaceAll("-", " ")
            let index = cData.cursos.findIndex(cur => cur.nombre === nombre)
            if (index > -1) {
                setCurso(cData.cursos[index])
            } else {
                let w = [where('nombre', '==', nombre)]
                obtenerColWheres({col: 'cursos', wheres: w}).then((dox) => {
                    if (dox.res && dox.data[0]) {
                        setCurso(dox.data[0])
                    }
                })
            }
        }


    }, [parms])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Detalle_Educacion item={curso}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 26 : 0}}>
                <Detalle_Complementos item={curso}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Indicadores/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -12}}>
                <Home_Documentos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Preguntas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14, mb: 14}}>
                <Home_Testimonios/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Detalle_Oferta